import {createContext} from 'react';

const MaterialsWizardContext = createContext({
  wizardSteps: [],
  currentGroups: [],
  wizardGroup: null,
  featureGroup: null,
}); // check LookWizardHooks.js

// export const MaterialsWizardContextReducer = (state = {}, action) => {
//   return {...state, ...action};
// }

export default MaterialsWizardContext;
